//@ts-check
import { ApiHelper } from './apiHelper';

export class AddressManagerApi {
    loadAddresses(postcode, token, callback = null, failureCallback = null) {
        var query = encodeURI(`?postcode=${postcode || ''}`);
        var dataUrl = '/api/addressmanager/addresses' + query;
        new ApiHelper().getDataSecure(
            dataUrl,
            token,
            callback,
            failureCallback
        );
    }

    loadAddress(moniker, token, callback = null, failureCallback = null) {
        var query = encodeURI(`?moniker=${moniker || ''}`);
        var dataUrl = `/api/addressmanager/details` + query;
        new ApiHelper().getDataSecure(
            dataUrl,
            token,
            callback,
            failureCallback
        );
    }

    async UpdateAddress(
        data,
        token,
        successCallback,
        failureCallback,
        signal,
        options = { skipToastNotification: false }
    ) {
        const dataUrl = '/api/addressmanager/updateAddress';

        await new ApiHelper().postDataWithResponseSecure(
            dataUrl,
            data,
            token,
            successCallback,
            failureCallback,
            signal,
            options
        );
    }
}
